import type { IconProps } from '../types/IconProps.ts';
export const Grid2x2Plus: IconProps = {
    name: 'Grid2x2Plus',
    children: [
        `<path d="M12 21H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v8M3 12h18M12 3v18M19 16v6M16 19h6" />`,
    ]
};